import React, { Component } from 'react';
import { Combobox } from 'react-input-enhancements';
import { FormControl } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


class CountryResourcesSelector extends Component {
  constructor(props){
    super(props);
    this.state = {
      value: '',
      placeholder: ''
    }
    this.onChange = this.onChange.bind(this);
  }

  componentWillMount(){
    // if(this.props.allCountres === this.props.countries){
    //   this.setState({ value: 'All Countries'})
    // }
  }

   onChange(val){
     this.setState({ value: val.target.value});
    }

  onClick(){
    //this.setState({ value: ""});
  }

  onSelect(val){
    if(val === undefined){
      alert("Please select a country from dropdown")
      return false;
    }
    this.props.addCountry(val);
    this.setState({ value: ""});


    //else if(this.props.countries.length > 10){
    //   this.props.addCountry(val);
    //   this.setState({ value: ""});
    // } else if(this.props.countries.includes(val)){
    //   alert(`${val} is already selected`)
    // } else {
    //   this.props.addCountry(val)
    //   this.setState({ value: ""});
    // }
  }


    render(){

      const { allCountries, countries } = this.props;
      const { placeholder } = this.state;
      //var countriesSelect = ['All Countries'];
      //var countriesSelect = countriesSelect.concat(allCountries);
      var countriesSelect = allCountries

      return (
        <div>
          <Combobox
            options={countriesSelect}
            onChange={this.onChange}
            onSelect={this.onSelect.bind(this)}
            optionFilters={[]}
            autosize
            >
              {inputProps =>
                <FormControl
                  {...inputProps}
                  type='text'
                  id='country'
                  placeholder={countries.length === allCountries.length? 'All Countries':'Select Country'}
                  style={{width: "330px"}}
                  value={this.state.value}
                  onFocus={this.onClick.bind(this)}
                />
              }
            </Combobox>
            <FontAwesomeIcon icon="search" style={{color: "#c4c4c4"}}/>
        </div>
      );
  }
}

export default CountryResourcesSelector



// WEBPACK FOOTER //
// ./src/components/CountryResourcesSelector.js